export const COW_WIDGET_CONNECTOR_ID = 'cow-widget'
export const SAFE_CONNECTOR_ID = 'safe'
export const WALLET_CONNECT_CONNECTOR_ID = 'walletConnect'
